<div class="custom-drawer-container oph-scroll-bar">
  <div class="mobile-menu" *ngIf="showNavbar$ | async">
    <div class="mobile-menu-content">
      <mobile-navbar [user]="activeUser$ | async" [routerUrl]="routerUrl$ | async" (logout)="onLogout()" />
    </div>
  </div>

  <div class="main-content">
    <ng-content></ng-content>
  </div>
</div>
